import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Methode from "@/pages/Methode";
import Assessment from "@/pages/Assessment";
import Result from "@/pages/Result";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/methode" element={<Methode />} />
          <Route path="/kompass" element={<Assessment />} />
          <Route path="/ergebnis/:id" element={<Result />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
